const maxEquipValueError = 'Max equip value should be greater than min equip value';
const MESSAGES = {
  COMMON: {
    DATA_REFRESHED: "Data refreshed",
    NO_CHANGES_TO_SAVE: "No changes to save",
    LOADING_DATA: "Error in loading the data",
    GRID_DATA_FETCH_FAILED: "Something went wrong",
    NO_ROUTE_SELECTED: "Please select at least one route to print",
    CUSTOMER_GEOFENCE_FETCH_FAILED: "Failed to fetch customer geofence",
  },
  ANCHORPOINT: {
    DROP_SUCCESS: "Successfully dropped anchor point",
    DROP_FAILURE: "Error while dropping anchor point",
    DISABLED_ANCHORPOINT: "Enable anchor point to assign routes",
  },
  FIND_NEARBY_ROUTES: {
    NO_ROUTES: "No near by routes found",
    FETCH_DATA_FAILURE: "Error while fetching near by routes",
  },
  FIRST_STOP: {
    MARK_SUCCESS: "Successfully marked as first stop",
    MARK_FAILURE: "Error while marking first stop",
    UNMARK_SUCCESS: "Successfully unmarked as first stop",
    UNMARK_FAILURE: "Error while unmarking last stop",
  },
  LAST_STOP: {
    MARK_SUCCESS: "Successfully marked as last stop",
    MARK_FAILURE: "Error while marking last stop",
    UNMARK_SUCCESS: "Successfully unmarked as last stop",
    UNMARK_FAILURE: "Error while unmarking last stop",
  },
  RUN_TSP: {
    FAILURE: "Route optimization failed",
  },
  ROUTE_PUBLISH: {
    START_SUCCESS: "Started route publishing",
    START_FAILURE: "Error publishing routes",
  },
  ROUTE_OPTIMIZATION: {
    START_SUCCESS: "Route optimization started",
    START_FAILURE: "Error while starting optimization",
    LAST_WAVE_MESSAGE: "Shipments arriving after last wave cut-off were routed to",
    OTHER_ROUTES_INFO_MESSAGE: "Routes not selected for optimization"
  },
  STOP_MOVE: {
    SUCCESS: "Stops updated",
    FAILURE: "Error while moving stops",
  },
  PARAMETERS: {
    UPDATE_SUCCESS: "Parameter custom value updated",
    UPDATE_FAILURE: "Error updating the parameter custom value",
  },
  ROUTE_UPDATE: {
    NO_ROUTE_SELECTED: "Please select atleast one route to update",
    NO_NONTRAPROUTE_SELECTED:
      "Please select atleast one non trap route to update",
    ROUTENAME_EXISTS: "Multiple routes cannot have same name",
    STARTTIME_EMPTY: "Cannot assign empty start time to a route",
    STARTTIME_INVALID: "Please assign a valid route start time",
    STATUS_EMPTY: "Cannot assign empty status to a route",
    TRAILER_EMPTY: "Cannot remove trailer from a route",
    ROUTETYPE_EMPTY: "Cannot remove route type from a route",
  },
  ROUTE_MERGE: {
    ROUTE_EXIST: "Route with same name already exists",
    IN_PROGRESS: "Merging routes in progress",
    FAILURE: "Failed to merge routes",
  },
  STOP_UPDATE: {
    NO_STOP_SELECTED: "Please select a delivery stop to update",
    ROUTE_EMPTY: "Cannot assign empty route to a stop",
    ROUTE_UNRTD: "Cannot assign a stop to UNRTD",
    STOP_TIME: "Stop time updated",
  },
  SHIPMENT_UPDATE: {
    NO_NON_ARRIVED_SHIPMENT_SELECTED:
      "Please select a non arrived shipment to update IBETA",
    NO_INPLAN_SHIPMENT_SELECTED:
      "Please select atleast one in plan shipment to update",
    NO_SHIPMENT_SELECTED: "Please select atleast one shipment to update",
    ROUTE_EMPTY: "Cannot assign empty route to a shipment",
    IBETA_EMPTY: "Cannot assign empty value to IB ETA",
    IBETA_INVALID: "Please assign a valid Datetime value for IB ETA",
    PREPTIME_EMPTY: "Cannot assign empty value to prep time",
    PREPTIME_INVALID: "Please assign a valid value for prep time",
    EARLY_LATE_CTA_EMPTY: "Cannot assign empty value to appointment window",
    EARLY_LATE_CTA_INVALID:
      "Please assign a valid value for appointment window",
    PSE_EMPTY: "Cannot assign empty value to PSE",
    MAX_TRAILER: "Cannot assign empty value to Max Trailer",
    PSE_ZEROVALUE: "Cannot assign zero value to PSE",
    IBETA_ARRIVED_PRO: "Cannot update IBETA for arrived shipments",
  },
  KPI: {
    FETCH_DATA_FAILURE: "Failed to get KPI data",
  },
  SCENARIO: {
    FETCH_DATA_FAILURE: "Error fetching scenario information",
    UPDATE_SCENARIONAME_EMPTY: "Scenario name cannot be empty",
    UPDATE_ACTIVESCENARIO_FAILURE: "Error updating Active scenario",
    COPY_NO_SCENARIO_SELECTED: "Please select the scenario to copy from",
    COPY_NO_EXISTING_SCENARIO_SELECTED:
      "Please select an existing scenario to copy from",
  },
  STEM_MILES: {
    FETCH_DATA_FAILURE: "Error fetching stem miles information",
    UPDATE_MILES_EMPTY: "Stem miles cannot be empty",
  },
  ZONE_MILES: {
    FETCH_DATA_FAILURE: "Error fetching zone miles information",
    UPDATE_MILES_EMPTY: "Zone miles cannot be empty",
  },
  TERMINAL_ACCESS: {
    FETCH_DATA_FAILURE: "Error fetching terminal access information",
    FETCH_TERMINAL_DATA_FAILURE: "Error fetching terminal list",
  },
  TRAILER: {
    UPDATE_CUSTOMVALUE_ISGREATER:
      "Custom value cannot be greater than available count",
  },
  WAVE: {
    FETCH_DATA_FAILURE: "Error fetching waves information",
    UPDATE_INVALID: "Wave name and wave time should have a valid value",
    UPDATE_WAVENAME_UNIQUE: "Wave Name must be unique",
    UPDATE_WAVETIME_UNIQUE: "Wave Time must be unique",
    UPDATE_DELETE_LAST_WAVE: "Cannot delete the last available wave",
  },
  STOP_MOVE_UNDO: {
    SUCCESS: "Stop move undo successful",
    FAILURE: "Failed to undo stop move",
  },
  LASSO: {
    UNDO_FAILED: "Undo failed",
    ROUTE_CREATION_FAILED: "Failed to create route",
  },
  NOTIFICATION: {
    DELETION_INPROGRESS: "Deleting notification...",
    DELETION_SUCCESS: "Notification deleted",
    DELETION_FAILED: "Failed to delete notification",
    FETCH_DATA_FAILURE: "Error fetching notifications",
    ADD_SUCCESS: "Notification Added",
    ADD_FAILED: "Failed to create new notification",
    UPDATE_SUCCESS: "Notification updated",
    UPDATE_FAILED: "Failed to update notification",
    NO_CHANGES: "No changes to save",
  },
  DRIVER_PREF: {
    FETCH_DATA_FAILURE: "Failed to fetch driver preferences",
    STARTTIME_EMPTY: "Zone start time cannot be empty",
    STARTTIME_INVALID: "Please assign valid start time to a zone",
  },
  GROUPED_DRIVER_PREF: {
    STARTTIME_EMPTY: "Start time cannot be empty",
    STARTTIME_INVALID: "Please assign valid start time",
    STARTTIME_DUPLICATE: "Duplicate start times are not allowed",
  },
  EQUIPMENT_MAPPING: {
    FETCH_DATA_FAILURE: "Error fetching equipment mapping data",
    UPDATE_SUCCESS: "Updated equipment mapping",
    UPDATE_FAILURE: "Failed to update equipment mapping",
  },
  PRO_HISTORY: {
    EMPTY_PROID_SEARCH: "Please enter a valid Pro ID to search",
  },
  DRIVER_PERFORMANCE: {
    FETCH_DATA_FAILURE: "Error fetching driver performance data",
  },
  NEXT_STOP_COMPLIANCE: {
    FETCH_DATA_FAILURE: "Error fetching next stop compliance information",
  },
  OPTIMIZATION_PICKUP: {
    OPTIMIZATION_FAILURE: "Error fetching optymized pickup solution",
    NO_ACTIVE_DRIVER: "There is no active driver available to optymize.",
    REASSIGNMENT_FAILURE: "Failed to Reassign Pickup",
    PICKUP_UPDATE_FAILURE: "Unable to update pickup properties",
    PICKUPWINDOW_EMPTY: "Cannot assign empty value to pickup window",
    PICKUPWINDOW_INVALID: "Please assign a valid value for pickup window",
    PSE_EMPTY: "Cannot assign empty value to PSE",
    PSE_ZEROVALUE: "Cannot assign zero value to PSE",
    UPDATE_SUCCESS: "Pickup properties updated",
  },
  GROUP_MESSAGE: {
    SUCCESS: "Message Sent Successfully!",
    FAILURE: "Message not sent, Please try again!",
  },
  CUSTOMER_MANAGEMENT: {
    FAILURE: "Failed to update customer data",
    SUCCESS: "Customer management data updated",
    GET_FAILURE: "Failed to fetch customer data",
    GET_CUSTOMER_ROUTES_FAILURE: "Failed to fetch customer routes",
  },
  PROCESS_DELIVERY: {
    EXCEPTION_TYPE_REQUIRED: "* Exception Type is required",
    OSND_DETAIL_REQUIRED: "* OS & D Detail is required",
    ADE_REQUIRED: "* ADE Number is required",
    ADE_REQUIRED_DYNAMIC: "* {label} is required",
    INVALID_ADE_LENGTH: "* ADE Number should be 7 to 9 digits",
    INVALID_ADE_LENGTH_DYNAMIC: "* {label} should be {length} digits",
    INVALID_ADE_LENGTH_RANGE_DYNAMIC: "* {label} should be {min} to {max} digits",
    ACCESSORIAL_REQUIRED: "* Please select at least one accessorial option to continue",
    SORT_AND_SEGREGATE_PIECES_REQUIRED: "* Piece Count should be greater than 0",
    EXCEPTION_PIECES_REQUIRED: "* Exception Pieces is required",
    EXCEPTION_DESCRIPTION_REQUIRED: "* Exception Description is required",
    PACKAGE_TYPE_REQUIRED: "* Package Type is required"
  },
  END_TRIP: {
    SUCCESS: "Trip Ended Successfully!",
    FAILURE: "End Trip Failed!",
  },
  TRAILER_HOOKED: {
    SUCCESS: "Trailer Hooked Successfully!",
    FAILURE: "Trailer Hook Failed!",
  },
  TRAILER_DROP: {
    SUCCESS: "Trailer Drop Successfully!",
    FAILURE: "Trailer Drop Failed!",
  },
  EQUIPMENT_DROP: {
    SUCCESS: "Equipment Drop Successfully!",
    FAILURE: "Equipment Drop Failed!",
  },
  BOBTAIL_PROCESSED: {
    SUCCESS: "Bobtail Processed Successfully!",
    FAILURE: "Bobtail Process Failed!",
  },
  DOLLY_HOOKED: {
    SUCCESS: "Dolly Hooked Successfully!",
    FAILURE: "Dolly Hook Failed!",
  },
  HOLIDAY: {
    EMPTY: "Unable to Update Customer Holiday: Please Provide a Valid Holiday Date",
    EXIST: "Holiday Already Added: No Changes Made"
  },
  START_TRIP: {
    SUCCESS: "Trip Started Successfully!",
    FAILURE: "Start Trip Failed!",
  },
  EQUIPMENT: {
    INVALID_UPDATE: {
      maxFeasibleTrailerLength: maxEquipValueError,
      maxEquipmentSize: maxEquipValueError,
      minEquipmentSize: 'Min equip value should be less than max equip value',
    },
    PICKUP_SHIPMENT: 'Pickup equipment update is not enabled',
    TRAILER_MISSING: "Please hook a trailer or bobtail to assign pickup",
  },
  UPDATE_PRO_IN_PLAN:{
    PRO_STATUS_NOT_SELECTED: '*Pro status is required'
  },
  PROCESS_PICKUP_OR_DELIVERY:{
    EXCESSIVE_LENGTH_DESCRIPTION:"Does the Pro have Excessive length?"
  },
  TRAILER_INVENTORY: {
    NO_TRAILER_AVAILABLE_TO_ADD : "No trailers available to add",
    TRAILER_TYPE_UPDATED: "Trailer type updated",
    NEW_TRAILER_TYPE_ADDED: "New trailer type added",
    TRAILER_TYPE_MISSING_ERROR: "Please select a trailer type to add",
    AVAILABLE_COUNT_MISSING_ERROR: "Available count is required",
    AVAILABLE_COUNT_GREATER_THAN_OR_EQUAL_TO_ZERO_ERROR: "Available count should be greater than or equal to 0",
    AVAILABLE_COUNT_GREATER_ZERO_ERROR: "Available count should be greater than 0",
    PSE_COUNT_GREATER_ZERO_ERROR:"Max PSE count should be greater than 0",
  },
  USAGE_REPORT: {
    FETCH_PUBLISHED_TERMINALS_FAILURE: "Error fetching published terminals",
    FETCH_USAGE_DETAILS_FAILURE: "Error fetching usage details",
    SELECT_DATE_RANGE: "Please select a date range",
    SELECT_TERMINAL: "Please select at least one terminal",
  }
};

export default MESSAGES;
